module.exports = __webpack_public_path__ + "img/money.68547a5a.png";